import Base from './base'

export type ActivityHistoryQueryResponse = {
  data?: unknown
  metadata?: {
    paging?: {
      next_page?: number | null
    }
  }
}

export type OpportunityActivityHistoryParams = {
  opportunityCrmId: string
  personIds: number[]
  types: readonly string[]
  page: number
  perPage: number
}

const ACCOUNT_TYPES = ['note']

const ACCOUNT_FOR_PEOPLE_TYPES = ['dnc_event']

const PERSON_TYPES = [
  'added_to_cadence',
  'call',
  'completed_action',
  'dnc_event',
  'email_reply',
  'meeting',
  'meeting_logged',
  'note',
  'received_email',
  'requested_email',
  'residency_change',
  'sent_email',
  'success',
]

export default class ActivityHistories extends Base {
  allForAccountId(accountId: number) {
    const params = new URLSearchParams()
    params.append('per_page', '100')
    params.append('sort_by', 'occurred_at')
    params.append('sort_direction', 'DESC')
    params.append('_resource[]', `account,${accountId}`)
    params.append('_resource[]', `account_for_people,${accountId}`)
    params.append('_resource[]', `people_at_account,${accountId}`)
    ACCOUNT_TYPES.forEach(t => params.append('type[account][]', t))
    ACCOUNT_FOR_PEOPLE_TYPES.forEach(t => params.append('type[account_for_people][]', t))
    PERSON_TYPES.forEach(t => params.append('type[person][]', t))
    params.append('excluded_tags[]', 'secondary')

    return this.api.get(`activity_histories?${params.toString()}`)
  }

  allForOpportunity({
    opportunityCrmId,
    personIds,
    types,
    page,
    perPage,
  }: OpportunityActivityHistoryParams): Promise<ActivityHistoryQueryResponse> {
    const params = new URLSearchParams()
    params.append('page', String(page))
    params.append('per_page', String(perPage))
    params.append('_resource[]', `crm_opportunity,${opportunityCrmId}`)
    personIds.forEach(personId => params.append('_resource[]', `person,${personId}`))
    types.forEach(type => params.append('type[]', type))
    params.append('excluded_tags[]', 'secondary')

    return this.api.post(`activity_history_queries?${params.toString()}`)
  }
}
